export const displayText = (
  input: string | Array<string>,
  delimiter = ', '
): string => {
  if (!input) return '';
  if (Array.isArray(input)) {
    return input.join(delimiter);
  }

  return input;
};
